/**
 * One home for the words we use when asking for a permission. The onboarding
 * notifications screen, the in-app browse card and the welcome email all read
 * from here so the promise we make is identical everywhere.
 */

export const NOTIFICATIONS_COPY = {
  /** Headline on the onboarding screen and the in-app card. */
  heading: "Never miss a good spot",
  /** One line on what the user actually gets. */
  body: "Know if it's busy, quiet, or worth the drive, before you go.",
  /** The three things we will actually send. Used on the onboarding screen. */
  reasons: [
    "A new work-friendly café opens near you",
    "One of your saved spots is worth a visit today",
    "Your check-in streak is about to lapse",
  ],
  enableCta: "Turn on notifications",
  declineCta: "Not now",
  /** Realistic push wording for the preview mockup. Matches what we send. */
  preview: {
    title: "New place to get grounded",
    body: "Maru just joined, and it's a solid work spot.",
  },
  /** Reassurance line. No dashes anywhere in user-facing copy. */
  reassurance: "A few a month at most. You can turn them off any time.",
} as const;

export const LOCATION_COPY = {
  heading: "Where are you based?",
  body: "Set your home area so we can notify you when new work-friendly cafes are added nearby.",
  /** Shown just above the detect button, only when the ask is unresolved. */
  why: "We only use your location to sort cafés by how close they are. It is never shared.",
  detectCta: "Use my current location",
} as const;
